import React from 'react';
import DynamicRouteResolver from './DynamicRouteResolver';
import { PageProvider } from '../context/PageContext';
import PropTypes from 'prop-types';

const DynamicRoute = (props) => {

    return (
        <PageProvider>
            <DynamicRouteResolver {...props} />
        </PageProvider>
    );
};

DynamicRoute.propTypes = {
    trackerId: PropTypes.string
};

export default DynamicRoute;
